import {useState, useCallback, useEffect, useRef} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {defaultTheme} from '@stencil/build-theme';

import {
  detailsUnifSelector,
  occupancyRoomsSelector,
  multiRoomArcInfo,
  isEntirePropertySelector,
  hotelDetailsSelector,
} from '@stencil/hotels-cg-reducer/src/details/selectors';
import HappyDropDownIcon from '@stencil/icons/src/HappyDropDownIcon/HappyDropDownIcon';

import * as S from './AddRoomFlow.styles';
import MultiRoomPaxModal from '../MultiRoomPaxModal/MultiRoomPaxModal';
import {
  getAdultandChildTxt,
  getCgRPCRoomsPaxCount,
  getMultiRoomKey,
  isArcReached,
  isPayModeSimilar,
  setARCObjCg,
} from '@stencil/hotels-utils/src/common-utils';
import {multiRoomTextCreator, RoomCase} from '@stencil/hotels-utils/src/details-utils';
import {updateArcReachedForRoomCode} from '@stencil/hotels-cg-reducer/src/details/actions';
import {detailsPagePushGaThunk} from '@stencil/hotels-ga/src';
import {gaConfig} from '@stencil/hotels-config';
import {omnitureThunk, omnitureConfig} from '@stencil/omniture-analytics/src';
import {
  detailsClick,
  DetailsPageComponents,
} from '@stencil/omniture-analytics/src/constants/details';

const AddRoomFlow = ({roomData, roomDefaultImage}) => {
  const {DetailsGAClickEventActions} = gaConfig;
  const {multiRoomEventActions} = DetailsGAClickEventActions;

  const dispatch = useDispatch();
  const detailStoreData = useSelector(detailsUnifSelector);
  const hotelStaticDetails = useSelector(hotelDetailsSelector);
  const sellableType = roomData?.sellableType;
  const propertyTypeTag = hotelStaticDetails?.propertyType;
  const isEntireProperty = useSelector(isEntirePropertySelector);
  const myRef = useRef(null);

  const executeScroll = () => {
    let id = 'tt-' + roomData?.roomPriceCode + roomData?.roomTypeCode;
    let el = document.getElementById(id);
    if (el) {
      let offsetTop = el.offsetTop;
      // window.scrollTo(0,offsetTop-400);
      window.scroll({top: offsetTop - 290, behavior: 'smooth'});
    }
  };

  const {
    cartRequestPayload = {},
    cartRoomUIData = {},
    cartResponseData = {},
    cartPayMode,
  } = detailStoreData;
  const [showPaxList, setShowPaxList] = useState(false);

  const mprlData = useSelector(occupancyRoomsSelector);
  const arcInfoObj = useSelector(multiRoomArcInfo);

  const clickMe = () => {
    dispatch(
      omnitureThunk(omnitureConfig.pages.DetailsUnif, omnitureConfig.events.ctaClick, {
        cta: {
          name: `${DetailsPageComponents.AddRoomFlow}_${detailsClick.multiRoomEventActions.Add_room_clicked}`,
          type: omnitureConfig.ctaType.Button,
          componentName: DetailsPageComponents.AddRoomFlow,
          destination: '',
        },
      }),
    );
    /**
     * checkARCReached is invoked here because to check If Available room count is reached
     * For a particular Room code then don't allow to Add More rooms by
     * disabling the Add button in Pax Modal
     */
    checkARCReached(cartRequestPayload);
    setShowPaxList(true);
    executeScroll();
  };

  const addOverlayLayer = () => {
    try {
      document.getElementsByTagName('html')[0].className += 'lock-scroll';
      var modalDiv = document.getElementById('modal-root');
      modalDiv.innerHTML += `<div style="background: rgba(0,0,0,0.4);
      bottom: 0;
      left: 0;
      position: fixed;
      right: 0;
      top: 0;
      z-index: 98;
      margin: 0;"></div>`;
    } catch (error) {}
  };

  const closePWIModal = () => {
    setShowPaxList(false);
  };

  const checkARCReached = reqObject => {
    const {roomTypeCode} = roomData;
    let obj = setARCObjCg(arcInfoObj, roomTypeCode, mprlData, reqObject);
    dispatch(updateArcReachedForRoomCode(obj));
  };

  const getRoomWithAdultText = () => {
    let tpl = null;
    const {isRoomExists, totalRooms, adultCount, childCount} = getCgRPCRoomsPaxCount(
      cartRoomUIData,
      roomData?.roomPriceCode,
    );
    if (isRoomExists) {
      tpl = (
        <S.RoomUpgradeBtn
          disabled={!isPayModeSimilar(cartPayMode, roomData?.payModeNew)}
          onClick={clickMe}
          style={{
            width: '100%',
          }}
        >
          <S.FlexItemCenter>
            {`${multiRoomTextCreator({
              type: RoomCase.AddFlowButton,
              sellableType,
              isEntireProperty: isEntireProperty,
              totalRoomCount: totalRooms,
              propertyTypeTag: propertyTypeTag,
            })}`}
            <HappyDropDownIcon
              margin="0 0 0 1rem"
              height="1rem"
              width="1rem"
              fill={defaultTheme.colors.goWhite.base}
            />
          </S.FlexItemCenter>

          <S.PaxCountSpan>{getAdultandChildTxt(adultCount, childCount)}</S.PaxCountSpan>
        </S.RoomUpgradeBtn>
      );
    } else {
      tpl = (
        <S.AddBtn disabled={!isPayModeSimilar(cartPayMode, roomData?.payModeNew)} onClick={clickMe}>
          Add{' '}
          {multiRoomTextCreator({
            type: RoomCase.AddFlowButton,
            sellableType,
            isEntireProperty: isEntireProperty,
            totalRoomCount: totalRooms,
            propertyTypeTag: propertyTypeTag,
          })}
          <HappyDropDownIcon
            margin="0 0 0 1rem"
            height="1rem"
            width="1rem"
            fill={defaultTheme.colors.goBrandOrange.base}
          />
        </S.AddBtn>
      );
    }

    return tpl;
  };

  return (
    <>
      <S.AddBtnOuterWrapper id={'tt-' + roomData?.roomPriceCode + roomData?.roomTypeCode}>
        {getRoomWithAdultText()}
        {showPaxList && (
          <MultiRoomPaxModal
            roomPriceCode={roomData?.roomPriceCode}
            roomTypeCode={roomData?.roomTypeCode}
            roomName={roomData?.roomFlavorName}
            pwiData={roomData?.multiRoomPwi}
            roomData={roomData}
            roomDefaultImage={roomDefaultImage}
            propertyTypeTag={propertyTypeTag}
            onCloseClick={closePWIModal}
          />
        )}
      </S.AddBtnOuterWrapper>
    </>
  );
};

export default AddRoomFlow;
